import { render, staticRenderFns } from "./OpeningBalanceEntr.vue?vue&type=template&id=475b7065&scoped=true"
import script from "./OpeningBalanceEntr.vue?vue&type=script&lang=js"
export * from "./OpeningBalanceEntr.vue?vue&type=script&lang=js"
import style0 from "./OpeningBalanceEntr.vue?vue&type=style&index=0&id=475b7065&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b7065",
  null
  
)

export default component.exports